import { useState } from "react";
import { fetchAllergies } from "../../utils/patients/fetchAllergies";
import useProfileStore from "../../store/patient/profileStore";



const useManageAllergies = () => {
    const [loading, setLoading] = useState(false);
    const [allergies, setAllergies] = useState([]);
    const {profile} = useProfileStore()



  const handleFetchAllergies = async () => {
    setLoading(true);
    try{
      const response = await fetchAllergies(profile?.id)
      
      setAllergies(response.data);
      console.log(response.data);
      
    } catch(err) {
      console.log(err)
      window.location.href = "/pages/signin2";
      localStorage?.setItem("user", null)
      console.log("error error");

    } finally {
      setLoading(false)
    }
  };


  return {
    handleFetchAllergies,
    loading,
    allergies
  };

}

export default useManageAllergies;